import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap'
import { FaPlay } from 'react-icons/fa';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';

const HomeThreeSingleBlog = ({image_num,title,namee,city,linkk,vIds}) => {
   const [open, setOpen] = useState(false);   
   const setVid = () => {      
      setOpen(true)
   }
   return (
      <>
         {open && (
            <Modal show={open} style={{background: "transparent"}} >
               <ModalVideo channel='youtube' autoplay isOpen={open} videoId={vIds} onClose={() => setOpen(false)} />                 
          </Modal>
         )}

         <div className="col-lg-12 col-md-12" onClick={() => setVid(true)} style={{cursor:"pointer"}}>
            <div className="tp-blog-three mb-30 wow fadeInUp" data-wow-delay=".4s">
               <div className="tp-blog-three-img" >
                  <img src={`assets/img/testimonial/author-${image_num}.png`} className="img" alt="img-not-found"/>                  
               </div>
               
               {/* <div className="tp-blog-three-text" onClick={() => setVid(true)} style={{cursor:"pointer"}}>
                  <div className="tp-blog-three-text-meta text-white" style={{height:"auto", lineHeight:"normal", width:"95%", marginBottom: "0px", borderTopLeftRadius:"2px", borderBottomLeftRadius:"10px" }}>
                     <p className="tp-blog-three-title mb-0" style={{ lineHeight:"normal"}}>
                        <a href="/" onClick={event => event.preventDefault() } >{namee}</a>
                     </p>
                     <h4 className="mb-0 pb-1">
                        <a href="/" onClick={event => event.preventDefault()} >{title}</a>
                     </h4>
                  </div>                  
               </div> */}
                              
               <div className="tp-testimonial-two-qoute" style={{background:"#ea1c1ced", borderRadius:"10px", top:"40%", left:"40%", cursor:"pointer"}} onClick={() => setVid(true)} >
                  <i ><FaPlay /></i>
               </div>
               

               <Link to="" onClick={() => setVid(true)} style={{cursor:"pointer"}}>
                  <div className="tp-blog-three-text mt-3 p-2 tp-ud-name-box" >
                     <h4 className="tp-blog-three-title mb-1">
                        <Link to="">{namee}</Link>
                     </h4>
                     <div className="tp-blog-three-link">                        
                        <Link to="">{title}</Link>
                        <br/><Link to="">{city}</Link>
                     </div>
                  </div>
               </Link>

            </div>
         </div>
      </>
   );
};

export default HomeThreeSingleBlog;